import { CommonModule } from '@angular/common';
import { Component, inject, Signal } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FileModel } from '../file-manager-state/file-manager.model';
import { Store } from '@ngxs/store';
import { FileManagerState } from '../file-manager-state/file-manager.state';
import { FileManagerActions } from '../file-manager-state/file-manager.actions';
import { FuseConfirmationService } from '@fuse/services/confirmation';
import { FileManagerService } from '../file-manager.service';
import { saveAs } from 'file-saver';
import { MatProgressBarModule } from '@angular/material/progress-bar';


@Component({
    selector: 'app-file-details',
    imports: [
        CommonModule,
        MatButtonModule,
        MatIconModule,
        MatTooltipModule,
        MatSidenavModule,
        MatProgressBarModule
    ],
    templateUrl: './file-details.component.html',
    styleUrl: './file-details.component.scss',
})
export class FileDetailsComponent {
    private _store = inject(Store);
    private _fileManagerService = inject(FileManagerService);
    public fileDetails: Signal<FileModel> = this._store.selectSignal(FileManagerState.getFileDetails);
    private _fuseConfirmationService = inject(FuseConfirmationService);


    onClose() {
        this._store.dispatch(new FileManagerActions.SetFileDetailsDrawerState(false));
    }

    onDownloadFile() {
        // console.log(this.fileDetails().name);
        const dialogRef = this._fuseConfirmationService.open({
            title: 'Are you sure you would like to downlaod:',
            message: this.fileDetails().name,
            icon: {
                show: true,
                color: 'primary'
            },
            actions: {
                confirm: {
                    color: 'primary'
                },
            },

            dismissible: false
        });
        dialogRef.afterClosed().subscribe((result) => {
            if (result === 'confirmed') {
                this._fileManagerService.downloadFile(this.fileDetails()._id).subscribe((res: any) => {
                    saveAs(res, this.fileDetails().name);

                });
            }

        });
    }

    onDeleteFile() {
        const dialogRef = this._fuseConfirmationService.open({
            title: 'Are you sure you would like to Delete file:',
            message: `${this.fileDetails().name} <br><br> <strong class="text-red-500">This action cannot be undone!</strong>`,
            icon: {
                show: true,
                color: 'warn'
            },
            actions: {
                confirm: {
                    color: 'warn'
                },
            },

            dismissible: false
        });
        dialogRef.afterClosed().subscribe((result) => {
            if (result === 'confirmed') {
                this._store.dispatch(new FileManagerActions.DeleteFile(this.fileDetails()._id));
            }
        });
    }

    onEditDescription() {
        alert('Edit description');
    }



}
